export default context => {
    const click = function (e) {
        window.toggleHoverMenu($(this));
        window.toggleHoverMenu(
            $(this).data('menu')
                ? $($(this).data('menu'))
                : $(this).parent().find('ul.hover-menu')
        );
    }
    const blur = function (e) {
        window.toggleHoverMenu($(this), false);
        window.toggleHoverMenu($(this).parent().find('ul.hover-menu'), false);
    }
    $(".edit-community-cover > a", context).on('click', click).on('blur', blur)
    $(".edit-logo-link", context).on('click', click).on('blur', blur)
    $(".community-settings", context).on('click', click).on('blur', blur)
}
